export default {"src":"/_next/static/media/DHL.16f6bba2.svg","height":39,"width":176};